/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface CreditorAccount {
  schemeName: string;
  identification: string;
  name: string;
  secondaryIdentification: string;
}

export const creditorAccountSchema: Schema<CreditorAccount> = object({
  schemeName: ['SchemeName', string()],
  identification: ['Identification', string()],
  name: ['Name', string()],
  secondaryIdentification: ['SecondaryIdentification', string()],
});
